import Client from '../HttpClient';

const list = () => {
	return Client.get(`/admin/api/sub-item-group`);
};

const find = (code) => {
	return Client.get(`/admin/api/sub-item-group/${code}`);
};

const create = (payload) => {
	return Client.post(`/admin/api/sub-item-group`, payload);
};

const update = (code, payload) => {
	return Client.put(`/admin/api/sub-item-group/${code}`, payload);
};

const remove = (code) => {
	return Client.del(`/admin/api/sub-item-group/${code}`);
};

export default {
	list,
	find,
	create,
	update,
	remove,
};
